import { EnumLiteralsOf } from '../types/helpers'

export const ProjectTypeKeys = {
  ALL: 'all',
  STARRED: 'star',
  SEARCHING: 'searching',
  DEFAULT: 'default',
} as const

export type ProjectTypeKey = EnumLiteralsOf<typeof ProjectTypeKeys>
